<template>
    <div class="list-item flex-align-center" @click="toDetail(itemInfo)">
        <span class="text line-one-ellipsis">{{ itemInfo.title }}</span>
        <span class="date">{{ itemInfo.createtimedate }}</span>
    </div>
</template>
<script>
export default {
    props: {
        itemInfo: {
            default: {},
            type: Object,
        },
        url: {
            default: "",
            type: String,
        },
        target: {
            type: String,
        },
    },
    data() {
        return {};
    },
    methods: {
        toDetail(itemInfo) {
            console.log(itemInfo, this.url)
            // return
            if (itemInfo.category_id) {
                if (itemInfo.category_id == 57) {
                    if (itemInfo.url) {
                        window.open(itemInfo.url, "_blank");
                    } else {
                        this.$router.push({
                            path: this.url,
                            query: {
                                id: itemInfo.id,
                                categoryId: itemInfo.category_id
                            },
                        });
                    }
                } else if (itemInfo.url) {
                    window.open(itemInfo.url, "_blank");
                } else {
                    this.$router.push({
                        path: this.url,
                        query: {
                            id: itemInfo.id,
                            categoryId: itemInfo.category_id
                        },
                    });
                }
            } else {
                this.$router.push({
                    path: this.url,
                    query: { id: itemInfo.id },
                });
            }

        },
    },
};
</script>
<style scoped>
.list-item {
    margin-top: 15px;
    line-height: 1.2;
}

.text {
    flex: 1;
    margin-right: 20px;
    font-size: 16px;
    color: #121126;
}

.date {
    font-size: 16px;
    color: #6c6b76;
}

.list-item:hover .text,
.list-item:hover .date {
    color: #0760a6;
    cursor: pointer;
}
</style>